import { createClient } from "@supabase/supabase-js";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS. Set REACT_APP_SUPABASE_*
// in frontend/.env for both preview and production. The Supabase JS client uses
// PKCE for OAuth (mobile-Safari safe - no third-party cookies).

let supabaseUrl = (process.env.REACT_APP_SUPABASE_URL || "").trim().replace(/\/+$/, "");
// Defensively strip /rest/v1 if pasted by mistake
if (supabaseUrl.endsWith("/rest/v1")) {
  supabaseUrl = supabaseUrl.slice(0, -"/rest/v1".length);
}
const supabaseAnonKey = (process.env.REACT_APP_SUPABASE_ANON_KEY || "").trim();

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
    flowType: "pkce",
    storageKey: "fitnudge.supabase.auth",
  },
});
